exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrap .container {\n    height: 100%;\n}\n", ""]);

// exports
